'use strict';

import Price from './price';

function Commission (required, amount) {
  this.required = required;
  this.amount = new Price(amount);
}
const proto = Commission.prototype;

proto.isRequired = function () {
  return this.required;
};

proto.getLabel = function () {
  if (!this.required) {
    return '';
  }

  return 'ком. риэлт.:\u00A0' + (this.amount.getValue() ? this.amount.getLabel() : 'дог.');
};

export default Commission;



// WEBPACK FOOTER //
// ./src/classes/finance/commission.js